module.exports = __webpack_public_path__ + "img/Verification.1ff686c5.svg";